module.exports = __webpack_public_path__ + "img/ctc.e3ac6543.svg";